<div class="wrap">

  <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()" *ngIf="!confirmSignUp">
    <h2>Inscription</h2>

    <div class="input_group">
      <mat-form-field appearance="outline">
        <mat-label>Prénom</mat-label>
        <input matInput type="text" formControlName="firstname">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nom</mat-label>
        <input matInput type="text" formControlName="lastname">
      </mat-form-field>
    </div>

    <div class="input_group">
      <mat-form-field appearance="outline">
        <mat-label>Adresse mail</mat-label>
        <input matInput type="email" formControlName="email">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>N° de téléphone</mat-label>
        <input matInput type="tel" formControlName="phoneNumber">
      </mat-form-field>
    </div>




    <div class="btn_action">
      <button type="submit" class="confirm" [disabled]="signUpForm.invalid"
        [style.opacity]="signUpForm.invalid? .5 : 1">S'inscrire</button>
    </div>

  </form>

  <app-validation-animation *ngIf="confirmSignUp"
    [text]="'Votre compte a été créé, vérifiez votre boîte mail pour activer votre compte'"></app-validation-animation>

</div>
